// import '../styles/TransactionForm.css'

// const TransactionForm = ({ onSubmit, initialData = {}, mode = "add" }) => {
//     return (
//         <div className="transaction-form-container">
//             <form onSubmit={onSubmit} className="transaction-form">
//                 <label>שם הספק:</label>
//                 <input name="provider_name" type="text" defaultValue={initialData.provider_name || ''} required />
//                 <div className="radio-columns">
//                     <div className="radio-column">
//                         <div className="radio-header">אופן תשלום</div>
//                         {["שוברי קניה","העברה בנקאית", "העברה בנקאית ישירה", "תשלום לספק", "העברה לספק", "שיק"].map((method, index) => (
//                             <label key={index}>
//                                 <input
//                                     type="radio"
//                                     name="payment_method"
//                                     value={method}
//                                     defaultChecked={initialData.payment_method === method}
//                                     required
//                                 />
//                                 <span>{method}</span> {/* הטקסט עטוף ב-span לסדר */}
//                             </label>
//                         ))}
//                     </div>

//                     <div className="radio-column">
//                         <div className="radio-header">סעיף</div>
//                         {["סיוע ורווחה", "הכנסת כלה", 'שכ"ל', "כולל", "אחר"].map((category, index) => (
//                             <label key={index}>
//                                 <input
//                                     type="radio"
//                                     name="category"
//                                     value={category}
//                                     defaultChecked={initialData.category === category}
//                                     required
//                                 />
//                                 <span>{category}</span>
//                             </label>
//                         ))}
//                     </div>
//                 </div>


//                 <label>סכום:</label>
//                 <input name="amount" step="0.01" type="number" defaultValue={initialData.amount || ''} required />

//                 <label>תאריך:</label>
//                 <input name="date" type="date" defaultValue={initialData.date || ''} required />

//                 <label>הערות:</label>
//                 <textarea name="comments" defaultValue={initialData.comments || ''} />

//                 <button className="transaction_btn" type="submit" style={{ marginTop: '10px' }}>
//                     {mode === 'edit'
//                         ? <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="#7879F1" strokeWidth="2" viewBox="0 0 24 24">
//                             <path d="M12 20h9" />
//                             <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
//                         </svg>
//                         : <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2">
//                             <circle cx="12" cy="12" r="10" />
//                             <line x1="12" y1="8" x2="12" y2="16" />
//                             <line x1="8" y1="12" x2="16" y2="12" />
//                         </svg>}
//                     {mode === 'edit' ? 'עדכון פעולה' : 'הוספת פעולה'}
//                 </button>
//             </form>
//         </div>
//     );
// };

// export default TransactionForm;

import { useState } from 'react';
import '../styles/TransactionForm.css';

const TransactionForm = ({ onSubmit, initialData = {}, mode = "add" }) => {
    const initialMeetingDates = Array.isArray(initialData.meeting_dates) && initialData.meeting_dates.length > 0
        ? initialData.meeting_dates
        : (initialData.meeting_date ? [initialData.meeting_date] : ['']);

    const [paymentMethod, setPaymentMethod] = useState(
        initialData.payment_method || ''
    );
    const [paymentToSupplier, setPaymentToSupplier] = useState(
        initialData.payment_to_supplier || initialData.provider_payment_method || ''
    );
    const [welfareSubcategory, setWelfareSubcategory] = useState(
        initialData.welfare_subcategory || ''
    );
    const [category, setCategory] = useState(initialData.category || '');

    const isCheck = paymentMethod === 'שיק';
    const isWelfare = category === 'סיוע ורווחה';
    const isTherapy = welfareSubcategory === 'טיפול ע"י מטפל';
    const [amount, setAmount] = useState(initialData.amount || '');
    const [checkAmount, setCheckAmount] = useState(initialData.check_amount || '');
    const [meetingDates, setMeetingDates] = useState(initialMeetingDates);

    const updateMeetingDate = (index, value) => {
        setMeetingDates((currentDates) => currentDates.map((dateValue, currentIndex) => (
            currentIndex === index ? value : dateValue
        )));
    };

    const addMeetingDateField = () => {
        setMeetingDates((currentDates) => [...currentDates, '']);
    };

    const removeMeetingDateField = (index) => {
        setMeetingDates((currentDates) => {
            if (currentDates.length === 1) {
                return [''];
            }

            return currentDates.filter((_, currentIndex) => currentIndex !== index);
        });
    };

    return (
        <div className="transaction-form-container">
            <form onSubmit={onSubmit} className="transaction-form">
                <label>שם הספק:</label>
                <input
                    name="provider_name"
                    type="text"
                    defaultValue={initialData.provider_name || ''}
                    required
                />

                <div className="radio-columns">
                    <div className="radio-column">
                        <div className="radio-header">תשלום לספק</div>
                        <label>
                            <input
                                type="radio"
                                name="payment_to_supplier"
                                value="העברה בנקאית לספק"
                                checked={paymentToSupplier === 'העברה בנקאית לספק'}
                                onClick={() => {
                                    if (paymentToSupplier === 'העברה בנקאית לספק') {
                                        setPaymentToSupplier('');
                                    }
                                }}
                                onChange={() => setPaymentToSupplier('העברה בנקאית לספק')}
                            />
                            <span>העברה בנקאית לספק</span>
                        </label>
                        <input type="hidden" name="payment_to_supplier" value={paymentToSupplier} />

                        <div className="radio-header" style={{ marginTop: '10px' }}>תשלום לנתמך</div>
                        {["שובר קנייה", "העברה בנקאית ישירה", "שיק", "תמיכה שוות כסף"].map((method, index) => (
                            <label key={index}>
                                <input
                                    type="radio"
                                    name="payment_method"
                                    value={method}
                                    defaultChecked={initialData.payment_method === method}
                                    onChange={(e) => setPaymentMethod(e.target.value)}
                                    required
                                />
                                <span>{method}</span>
                            </label>
                        ))}
                    </div>

                    <div className="radio-column">
                        <div className="radio-header">סעיף</div>

                        {["סיוע ורווחה", "הכנסת כלה", 'שכ"ל', "כולל", "אחר"].map((cat, index) => (
                            <div key={index}>
                                <label>
                                    <input
                                        type="radio"
                                        name="category"
                                        value={cat}
                                        defaultChecked={initialData.category === cat}
                                        onChange={(e) => {
                                            setCategory(e.target.value);
                                            if (e.target.value !== 'סיוע ורווחה') {
                                                setWelfareSubcategory('');
                                                setMeetingDates(['']);
                                            }
                                        }}
                                        required
                                    />
                                    <span>{cat}</span>
                                </label>

                                {cat === 'סיוע ורווחה' && isWelfare && (
                                    <div style={{ marginRight: '18px', marginBottom: '8px' }}>
                                        {["טיפול ע\"י מטפל", "סיוע כספי פרטי"].map((option, subIndex) => (
                                            <label key={subIndex}>
                                                <input
                                                    type="radio"
                                                    name="welfare_subcategory"
                                                    value={option}
                                                    checked={welfareSubcategory === option}
                                                    onChange={(e) => {
                                                        setWelfareSubcategory(e.target.value);
                                                        if (e.target.value !== 'טיפול ע"י מטפל') {
                                                            setMeetingDates(['']);
                                                        } else if (meetingDates.length === 0) {
                                                            setMeetingDates(['']);
                                                        }
                                                    }}
                                                    required
                                                />
                                                <span>{option}</span>
                                            </label>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                {isTherapy && (
                    <>
                        <label>מספר מפגשים:</label>
                        <input
                            name="meeting_count"
                            type="number"
                            min="1"
                            value={meetingDates.filter(Boolean).length || ''}
                            readOnly
                            required
                        />

                        <label>תאריכי מפגשים:</label>
                        {meetingDates.map((meetingDateValue, index) => (
                            <div key={`meeting-date-${index}`} className="meeting-date-row">
                                <input
                                    name="meeting_dates"
                                    type="date"
                                    value={meetingDateValue || ''}
                                    onChange={(e) => updateMeetingDate(index, e.target.value)}
                                    required
                                    className="meeting-date-input"
                                />
                                <button
                                    type="button"
                                    onClick={addMeetingDateField}
                                    className="meeting-date-btn meeting-date-btn-add"
                                    aria-label="הוספת תאריך מפגש"
                                >
                                    +
                                </button>
                                <button
                                    type="button"
                                    onClick={() => removeMeetingDateField(index)}
                                    className="meeting-date-btn meeting-date-btn-remove"
                                    aria-label="הסרת תאריך מפגש"
                                    disabled={meetingDates.length === 1}
                                >
                                    -
                                </button>
                            </div>
                        ))}
                    </>
                )}

                {isCheck && (
                    <>
                        <label>תאריך שיק:</label>
                        <input
                            type="date"
                            name="check_date"
                            defaultValue={initialData.check_date || ''}
                            required
                        />

                        <label>מספר שיק:</label>
                        <input
                            type="text"
                            name="check_number"
                            defaultValue={initialData.check_number || ''}
                            required
                        />

                        <label>סכום שיק:</label>
                        <input
                            type="number"
                            step="0.01"
                            name="check_amount"
                            value={checkAmount}
                            onChange={(e) => {
                                setCheckAmount(e.target.value);
                                setAmount(e.target.value);
                            }}
                            required
                        />
                    </>
                )}

                <label>סכום:</label>
                <input
                    name="amount"
                    step="0.01"
                    type="number"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    readOnly={isCheck}
                    required
                />

                <label>תאריך:</label>
                <input
                    name="date"
                    type="date"
                    defaultValue={initialData.date || ''}
                    required
                />

                <label>הערות:</label>
                <textarea
                    name="comments"
                    defaultValue={initialData.comments || ''}
                />

                <button
                    className="transaction_btn"
                    type="submit"
                    style={{ marginTop: '10px' }}
                >
                    {mode === 'edit' ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="#7879F1" strokeWidth="2" viewBox="0 0 24 24">
                            <path d="M12 20h9" />
                            <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2">
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="8" x2="12" y2="16" />
                            <line x1="8" y1="12" x2="16" y2="12" />
                        </svg>
                    )}

                    {mode === 'edit' ? 'עדכון פעולה' : 'הוספת פעולה'}
                </button>
            </form>
        </div>
    );
};

export default TransactionForm;
